// class to create a countdown timer
class CountdownTimer {
  // setup timer values
  constructor({
    selector,
    targetDate,
    backgroundColor = null,
    foregroundColor = null,
  }) {
    this.selector = selector;

    this.targetDate = new Date(targetDate);

    this.backgroundColor = backgroundColor;
    this.foregroundColor = foregroundColor;
    // console.log(this.selector);
    // grab divs on frontend using supplied selector ID
    this.refs = {
      days: document.querySelector(`${this.selector} [data-value="days"]`),
      hours: document.querySelector(`${this.selector} [data-value="hours"]`),
      mins: document.querySelector(`${this.selector} [data-value="minutes"]`),
      secs: document.querySelector(`${this.selector} [data-value="seconds"]`),
    };
  }

  getTimeRemaining(endtime) {
    //console.log(endtime);
    const total = Date.parse(endtime) - Date.parse(new Date());
    const days = Math.max(0, Math.floor(total / (1000 * 60 * 60 * 24)));
    const hours = Math.max(0, Math.floor((total / (1000 * 60 * 60)) % 24));
    const mins = Math.max(0, Math.floor((total / 1000 / 60) % 60));
    const secs = Math.max(0, Math.floor((total / 1000) % 60));
    return {
      total,
      days,
      hours,
      mins,
      secs,
    };
  }

  updateTimer({ days, hours, mins, secs }) {
    if (this.refs.days) {
      this.refs.days.textContent = days;
    }
    if (this.refs.hours) {
      this.refs.hours.textContent = hours;
    }

    if (this.refs.mins) {
      this.refs.mins.textContent = mins;
    }

    if (this.refs.secs) {
      this.refs.secs.textContent = secs;
    }

    if ((days || hours || mins || secs) < 0) {
      if (document.querySelector(`${this.selector}`)) {
        document.querySelector(`${this.selector}`).classList.add("timer-ended");
      }

      if (
        document.querySelector(`${this.selector}`) &&
        document
          .querySelector(`${this.selector}`)
          .closest(".countdown__wrapper")
      ) {
        document
          .querySelector(`${this.selector}`)
          .closest(".countdown__wrapper")
          .remove();
      }
    }
  }

  startTimer() {
    if (this) {
      console.log(this.targetDate);
      const timer = this.getTimeRemaining(this.targetDate);

      this.updateTimer(timer);
      // this.updateColors();
      setInterval(() => {
        const timer = this.getTimeRemaining(this.targetDate);
        this.updateTimer(timer);
      }, 1000);
    }
  }
}
